import { useEffect, useState } from 'react';

export interface AppVersionInfo {
  version: string;
  lastUpdated: string;
}

export function useAppVersionInfo() {
  const [info, setInfo] = useState<AppVersionInfo | null>(null);

  useEffect(() => {
    let cancelled = false;

    fetch('/version.json', { cache: 'no-store' })
      .then((response) => (response.ok ? response.json() : Promise.reject()))
      .then((data: AppVersionInfo) => {
        if (!cancelled) setInfo(data);
      })
      .catch(() => {
        if (!cancelled) setInfo(null);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return info;
}
